const Arive = () => {
    return (
        <div className="container-fluid p-4">
            <h1>Arive</h1>
        </div>
    )
}

export default Arive;